
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AuthPage from './authPage';
import App from './App';
import { FullPageLoader } from './riskManager/components/HuginnLoader';


const AuthWrapper = () => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <FullPageLoader />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/*" element={isAuthenticated ? <App /> : <Navigate to="/auth" />} />
      </Routes>
    </Router>
  );
};

export default AuthWrapper;
